import CollapsedList from './collapsed-list';

export default function EquipeRanking() {
  const blocks = document.querySelectorAll('.ranking-block');
  for (const block of blocks) {
    const container = block.querySelector('.ranking-block__content');
    const template = container.querySelector('template').content;
    fetch(`/equipe/class_sections/${encodeURIComponent(block.dataset.sectionId)}.json`)
    .then((res) => {
      return res.json();
    })
    .then(body => {
      container.classList.add('loaded');
      const riders = body.starts;

      for (const rider of riders) {
        const li = template.cloneNode(true);
        li.querySelector('.rider').textContent = rider.rider_name;
        li.querySelector('.club').textContent = rider.club_name;
        li.querySelector('.horse').textContent = rider.horse_name;

        const scoreTotal = rider.results && rider.results.find(x => x.type === 'ScoreSummaryTotal');

        if (scoreTotal) {
          li.querySelector('.score').textContent = scoreTotal.score;
        }
        container.appendChild(li);
      }

      if (container.querySelectorAll('li').length > 4) {
        container.classList.add('collapsed-list');
        CollapsedList();
      }
    })
    .catch(err => {
      console.error(err);
      container.classList.add('error');
    });

  }
};
